import NavBar from "../components/Nav";
import ViewJobs from "../components/ViewJobs";

const Jobs = () => {
	return (
		<>
			<NavBar />
			<ViewJobs />
		</>
	);
};

export default Jobs;
